import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const TextModuleAnimation = () => {
  const containers = document.querySelectorAll(".text-module");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
  };
  const applyAnimations = () => {
    containers.forEach((container) => {
      const headline = container.querySelectorAll(".text-module__headline");
      const subline = container.querySelectorAll(".text-module__subline");
      const text = container.querySelectorAll(".text-container .text-element");
      const button = container.querySelectorAll(".text-container .btn");

      if (!headline.length && !subline.length && !text.length && !button.length)
        return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (headline.length) {
        tl.to(headline, { ...base, x: 0 });
      }

      if (subline.length) {
        tl.to(subline, { ...base, x: 0 });
      }

      if (text.length) {
        tl.to(text, { ...base, stagger: 0.2 });
      }

      if (button.length) {
        tl.to(
          button,
          {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "back.out(1.7, 0.5)",
          },
          "-=0.4",
        );
      }
    });
  };
  applyAnimations();
};

export default TextModuleAnimation;
